module.exports = __webpack_public_path__ + "img/vu.vu80c6f8a.svg";